import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _NODE_ELEMENTS;
export var NODE_TYPES = {
  heading1: 'heading1',
  heading2: 'heading2',
  heading3: 'heading3',
  heading4: 'heading4',
  heading5: 'heading5',
  heading6: 'heading6',
  paragraph: 'paragraph',
  preformatted: 'preformatted',
  strong: 'strong',
  em: 'em',
  listItem: 'list-item',
  oListItem: 'o-list-item',
  list: 'group-list-item',
  oList: 'group-o-list-item',
  image: 'image',
  embed: 'embed',
  hyperlink: 'hyperlink',
  label: 'label',
  span: 'span'
};
export var NODE_ELEMENTS = (_NODE_ELEMENTS = {}, _defineProperty(_NODE_ELEMENTS, NODE_TYPES.heading1, 'h1'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.heading2, 'h2'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.heading3, 'h3'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.heading4, 'h4'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.heading5, 'h4'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.heading6, 'h6'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.paragraph, 'p'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.strong, 'strong'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.em, 'em'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.listItem, 'li'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.oListItem, 'li'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.list, 'ul'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.oList, 'ol'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.hyperlink, 'a'), _defineProperty(_NODE_ELEMENTS, NODE_TYPES.label, 'span'), _NODE_ELEMENTS);